const defaultRender = (value) => (value ? value : "--");

const statusFilter = [
  { text: "Pending", value: "PENDING" },
  { text: "Approved", value: "APPROVED" },
];

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
  },
  {
    title: "Email",
    dataIndex: "email",
    render: defaultRender,
  },
  {
    title: "Amount",
    dataIndex: "amount",
    render: defaultRender,
  },
  {
    title: "Invoice",
    dataIndex: "invoice",
    render: defaultRender,
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "statusText",
    render: defaultRender,
    filters: statusFilter,
    onFilter: (value, record) => {
      return record?.status === value;
    },
  },
];

export default columns;
